import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CraftRow } from "../models/Craft";
import { deleteCraft, upsertCraft } from "../repositories/CraftsRepository";
import { CRAFTS_QUERY_KEYS } from "./useCraftsQueries";

type Callbacks = {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
};

export const useUpsertCraft = ({ onSuccess, onError }: Callbacks = {}) => {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationFn: (craft: CraftRow) => upsertCraft(craft),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: CRAFTS_QUERY_KEYS.all });
			onSuccess?.();
		},
		onError: (error: Error) => onError?.(error),
	});

	return { upsertCraft: mutation.mutate, isSaving: mutation.isLoading };
};

export const useDeleteCraft = ({ onSuccess, onError }: Callbacks = {}) => {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationFn: (craftId: number) => deleteCraft(craftId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: CRAFTS_QUERY_KEYS.all });
			onSuccess?.();
		},
		onError: (error: Error) => onError?.(error),
	});

	return { deleteCraft: mutation.mutate, isDeleting: mutation.isLoading };
};
